/**
 * Field types that typically place PDF boxes on options / other, not only metadata.pdfLocation.
 * (Same idea as CreateFieldDialog OPTION_LIKE_FIELD_TYPES, minus inlineInput which uses content[].)
 */
export const OPTION_LEVEL_PDF_FIELD_TYPES = new Set([
  "checkbox",
  "checkboxWithOther",
  "radio",
  "radioWithOther",
  "decision",
  "decisionWithOther",
]);

/**
 * Single rect to use for Extra PDF output / linked bindings: primary pdfLocation if set,
 * otherwise first option (or other checkbox/radio/input) that has a page.
 *
 * @param {Object} field
 * @returns {{ pdfLocation: Object, lines: number } | null}
 */
export function getEffectivePdfLocationForExtraBinding(field) {
  if (!field?.metadata) return null;

  const primary = field.metadata.pdfLocation;
  if (primary && typeof primary.page === "number") {
    const lines =
      field.annotationMultiline != null && Number(field.annotationMultiline) > 0
        ? Number(field.annotationMultiline)
        : primary.lines != null && Number(primary.lines) > 0
          ? Number(primary.lines)
          : 0;
    return { pdfLocation: { ...primary }, lines };
  }

  if (!OPTION_LEVEL_PDF_FIELD_TYPES.has(field.type)) return null;

  const options = Array.isArray(field.metadata.options) ? field.metadata.options : [];
  for (const opt of options) {
    const pl = opt?.pdfLocation;
    if (pl && typeof pl.page === "number") {
      const lines = pl.lines != null && Number(pl.lines) > 0 ? Number(pl.lines) : 0;
      return { pdfLocation: { ...pl }, lines };
    }
  }

  const other = field.metadata.other;
  if (other?.checkbox?.pdfLocation && typeof other.checkbox.pdfLocation.page === "number") {
    const pl = other.checkbox.pdfLocation;
    const lines = pl.lines != null && Number(pl.lines) > 0 ? Number(pl.lines) : 0;
    return { pdfLocation: { ...pl }, lines };
  }
  if (other?.radio?.pdfLocation && typeof other.radio.pdfLocation.page === "number") {
    const pl = other.radio.pdfLocation;
    const lines = pl.lines != null && Number(pl.lines) > 0 ? Number(pl.lines) : 0;
    return { pdfLocation: { ...pl }, lines };
  }
  if (other?.input?.pdfLocation && typeof other.input.pdfLocation.page === "number") {
    const pl = other.input.pdfLocation;
    const lines = pl.lines != null && Number(pl.lines) > 0 ? Number(pl.lines) : 0;
    return { pdfLocation: { ...pl }, lines };
  }

  return null;
}
